/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import i from "prop-types";
import { registerForLocalization as m } from "@progress/kendo-react-intl";
import { classNames as p } from "@progress/kendo-react-common";
import { CalendarHeaderTitle as l } from "./CalendarHeaderTitle.mjs";
import { MIN_DATE as d, MAX_DATE as u } from "../../utils.mjs";
const s = class s extends t.Component {
  constructor() {
    super(...arguments), this.getTitle = () => {
      if (!this.props.currentDate)
        return "";
      const e = this.rangeLength - 1, a = this.props.service.title(this.props.currentDate), r = this.props.service.addToDate(this.props.currentDate, e);
      return e < 1 || !this.props.service.isInRange(r, this.min, this.max) ? a : `${a} - ${this.props.service.title(r)}`;
    }, this.handleTitleClick = (e) => {
      this.canMoveUp && this.props.bus.moveUp(this.props.activeView, e);
    };
  }
  get min() {
    return this.props.min !== void 0 ? this.props.min : s.defaultProps.min;
  }
  get max() {
    return this.props.max !== void 0 ? this.props.max : s.defaultProps.max;
  }
  get rangeLength() {
    return this.props.rangeLength !== void 0 ? this.props.rangeLength : s.defaultProps.rangeLength;
  }
  get canMoveUp() {
    return this.props.bus.canMoveUp(this.props.activeView);
  }
  render() {
    const e = this.getTitle(), a = p(
      "k-calendar-title"
    ), r = {
      children: e,
      value: e,
      view: this.props.activeView,
      className: a,
      onClick: this.handleTitleClick,
      disabled: !this.canMoveUp
    }, o = {
      headerTitleProps: r,
      commands: this.props.commands
    }, c = this.props.headerTitle ? /* @__PURE__ */ t.createElement(this.props.headerTitle, { ...r }, e) : /* @__PURE__ */ t.createElement(l, { ...r }, e), h = this.props.header ? /* @__PURE__ */ t.createElement(this.props.header, { ...o }) : /* @__PURE__ */ t.createElement(t.Fragment, null, c, /* @__PURE__ */ t.createElement("span", { className: "k-spacer" }), /* @__PURE__ */ t.createElement("span", { className: "k-calendar-nav" }, this.props.commands));
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        className: p("k-calendar-header", {
          "k-vstack": this.props.verticalView
        })
      },
      h
    );
  }
};
s.propTypes = {
  activeView: i.number.isRequired,
  currentDate: i.instanceOf(Date).isRequired,
  max: i.instanceOf(Date).isRequired,
  min: i.instanceOf(Date).isRequired,
  rangeLength: i.number
}, s.defaultProps = {
  rangeLength: 1,
  min: d,
  max: u
};
let n = s;
m(n);
export {
  n as Header
};
